import type { ApexOptions } from 'apexcharts'
import type { ComputedRef } from 'vue'
import { useI18n } from 'vue-i18n'

import { formatDate, ISO_DATE } from '@/lib/dateTime'

export interface ChartConfigParams {
  chartSeries: ComputedRef<{ x: string; y: number }[]>
  tooltipText: string
  onSelect?: (payload: string) => void
}

export function createBarChartConfig({
  chartSeries,
  tooltipText,
  onSelect,
}: ChartConfigParams): ApexOptions {
  const { t } = useI18n()
  return {
    chart: {
      type: 'bar',
      toolbar: { show: false },
      zoom: { enabled: false },
      animations: { enabled: false },
      events: {
        dataPointSelection(event, chartContext, config) {
          onSelect?.(chartSeries.value[0].data[config.dataPointIndex].x)
        },
      },
    },
    xaxis: {
      type: 'datetime',
      labels: { show: false },
      axisTicks: { show: false },
      axisBorder: { show: false },
    },
    yaxis: {
      show: false,
    },
    grid: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      custom({ w, dataPointIndex }) {
        const tooltip = t(tooltipText)
        const x = w.config.series[0].data[dataPointIndex].x
        const y = w.config.series[0].data[dataPointIndex].y
        return `${formatDate(x, ISO_DATE)} - ${tooltip} ${y?.toLocaleString() || 0}`
      },
    },
    legend: {
      show: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '95%',
      },
    },
    stroke: {
      show: false,
    },
  }
}
